


































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { app } from '@src/store/modules/app';
import { currency } from '@filters/shared-filters';
import InitialsBadge from '@components/header/navigation/initials-badge.vue';
import { investmentEntity } from '@store/modules/investment-entity';
import NavInvestmentEntityList from '@components/header/navigation/nav-investment-entity-list.vue';
import { user } from '@store/modules/user';

@Component({
	components: { InitialsBadge, NavInvestmentEntityList }
})
export default class UserDropdown extends Vue {
	@Prop()
	hasMultipleEntities!: boolean;

	@Prop()
	expanded!: boolean;

	$refs!: {
		userDropdown: HTMLElement;
	};

	currency = currency;

	private async handleLogout() {
		await app.revokeUserToken();
	}

	get eligibleForReferral(): boolean {
		return investmentEntity.userReferralEligibilityStatus != 'INELIGIBLE';
	}

	get referralAmount(): string {
		return user.invitationDetails?.invitationDetails.rewardPerInvite ?? '';
	}

	get userName(): string {
		return user.user?.firstName && user.user?.lastName
			? `${user.user.firstName} ${user.user.lastName}`
			: 'Your Account';
	}

	get dropdownExpanded(): boolean {
		return this.expanded;
	}

	@Watch('dropdownExpanded')
	onDropdownExpandedChange(expand: boolean): void {
		if (expand) {
			document.addEventListener('click', this.clickOutsideHandler);
		} else {
			document.removeEventListener('click', this.clickOutsideHandler);
		}
	}

	clickOutsideHandler(event: MouseEvent): void {
		if (this.$refs.userDropdown && !this.$refs.userDropdown.contains(event.target as Node)) {
			this.$emit('expandUserDropdown', false);
		}
	}

	toggleDropdown(): void {
		this.$emit('expandUserDropdown', !this.expanded);
	}
}
